<div id="layout" class="theme-cyan">
  <app-leftmenu></app-leftmenu>

  <!-- Main Body: Content -->
  <div class="main px-xl-5 px-lg-4 px-3">

    <!-- Body: -->
    <div class="main-body">

      <!-- Body: Header -->
      <div class="body-header border-bottom py-xl-3 py-2">
        <div class="container-fluid">

          <div class="row align-items-center">

            <!-- page title -->
            <div class="col-5 col-xl-4">
              <div class="media">
                <div class="media-body overflow-hidden">
                  <div class="d-flex align-items-center justify-content-between mb-1">
                    <h5 class="text-truncate mb-0 me-auto">Calendar</h5>
                  </div>
                  <small class="text-truncate text-muted">Total 658 (last update 1 month ago)</small>
                </div>
              </div>
            </div>

            <!-- page action  -->
            <div class="col-7 col-xl-8 text-end">
              <ul class="nav justify-content-end d-inline-flex">
                <li class="nav-item list-inline-item d-none d-md-block me-2">
                  <a href="javascript:void(0)" class="nav-link text-muted px-3" (click)="isCollapsed = !isCollapsed"
                    [attr.aria-expanded]="!isCollapsed" aria-controls="collapseBasic" title="Search this chat">
                    <i class="zmdi zmdi-search zmdi-hc-lg"></i>
                  </a>
                </li>
                <li class="nav-item list-inline-item d-none d-md-block me-2">
                  <a class="btn btn-sm btn-dark" href="javascript:void(0)">Add Event</a>
                </li>

                <!-- Mobile nav -->
                <li class="nav-item list-inline-item d-block d-sm-none px-3">
                  <div class="dropdown">
                    <a class="nav-link text-muted px-0" href="javascript:void(0)" data-bs-toggle="dropdown"
                      aria-haspopup="true" aria-expanded="false">
                      <i class="zmdi zmdi-more-vert zmdi-hc-lg"></i>
                    </a>
                    <div class="dropdown-menu dropdown-menu-right">
                      <a class="dropdown-item" href="javascript:void(0)">List view</a>
                      <a class="dropdown-item" href="javascript:void(0)">Grid view</a>
                      <a class="dropdown-item" href="javascript:void(0)">Add new</a>
                    </div>
                  </div>
                </li>
                <!-- Mobile nav -->
              </ul>

            </div>

          </div>

        </div>
      </div>
      <!-- Body: Search -->
      <div class="collapse" id="collapseBasic" [collapse]="isCollapsed" [isAnimated]="true">
        <div class="container-fluid py-2">

          <div class="row">
            <div class="input-group">
              <input type="text" class="form-control" placeholder="Search...">
              <div class="input-group-append">
                <span class="input-group-text text-muted"><small>0 / 0</small></span>
              </div>
              <div class="input-group-append dropdown" dropdown placement="bottom right">
                <button type="button" class="btn btn-secondary">Search</button>


                <button id="button-basic" dropdownToggle type="button" aria-controls="dropdown-basic"
                  class="btn btn-secondary dropdown-toggle dropdown-toggle-split ml-1">
                  <span class="sr-only">Toggle Dropdown</span>
                </button>
                <div id="dropdown-basic" *dropdownMenu class="dropdown-menu dropdown-menu-right" role="menu"
                  aria-labelledby="button-basic">
                  <a href="javascript:void(0);" class="dropdown-item">Action</a>
                  <a href="javascript:void(0);" class="dropdown-item">Another action</a>
                  <a href="javascript:void(0);" class="dropdown-item">Something else here</a>
                  <div role="separator" class="dropdown-divider"></div>
                  <a class="dropdown-item" href="javascript:void(0)">Separated link</a>
                </div>

              </div>
            </div>
          </div>

        </div>
      </div>

      <!-- Page Default -->
      <div class="body-page d-flex py-xl-3 py-2">
        <div class="container-fluid">

          <div class="row">
            <div class="col-12">
              <div class="card mb-3">
                <div class="card-body">
                  <!-- <div id='calendar'></div> -->
                  <app-fullcalender></app-fullcalender>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>
      <!-- End Page Default -->

    </div>
    <!-- End chat body -->

  </div>
  <!-- Main Body: Content -->
</div>
